import React, { useEffect } from 'react'
import { HorizontalBar } from 'react-chartjs-2';

import colorChats from '../../lib/colorChats'


  var tituloGrafico = ''

const mascaraLabel = (valor)=>{
  if(tituloGrafico === 'Atendimento por Quantidade'){
    return(valor);
  }else{
    return(parseFloat(valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}))
  }
}

const options = {
  legend: {
    display: false,
    position: 'top'
  },
  elements: {
    bar:{
      width:'500px'
    }
  },
  plugins:{
    datalabels:{
      display: true,
      color: "black",
      formatter: Math.round,
      anchor: "end",
      offset: -20,
      align: "start"
    }
  },
  // aspectRatio: 1,
  tooltips: {
    enabled: true,
    callbacks: {
      label: function(tooltipItem, data) {
        
        var label = mascaraLabel(data.datasets[0].data[tooltipItem.index]);
        var dataset = data.datasets[tooltipItem.datasetIndex]
        var total = dataset.data.reduce((total, currentElement) => parseFloat(total) + parseFloat(currentElement))
        var valor = dataset.data[tooltipItem.index]
        var porcentagem = parseFloat((valor/total*100).toFixed(1))
        label += ' ('+porcentagem+'%)'
        return label
      },
      title: function(tooltipItem, data) {
        return data.labels[tooltipItem[0].index]
      },
    }
  },
  scales: {
    yAxes: [
      {        
        ticks: {
          display: true,
          min: 0
        },        
        gridLines: {
          drawBorder: false,
          zeroLineColor: "transparent",
          color: "rgba(255,255,255,0.1)"
        }
      }
    ],
    xAxes: [
      {
        barThickness : 10,
        barPercentage: 0.8,
        gridLines: {
          drawBorder: true,
          color: "rgba(255,255,255,0.1)",
          zeroLineColor: "transparent"
        },
        ticks: {
          display: true
        }
      }
    ]
  }
}

  // const options = {
  //   indexAxis: 'y',
  //   elements: {
  //     bar: {
  //       borderWidth: 2,
  //     },
  //   },
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       position: 'right',
  //     },
  //     title: {
  //       display: true,
  //       text: 'Chart.js Horizontal Bar Chart',
  //     },
  //   },
  // };

  // const labels = ['January', 'February', 'March', 'April', 'May', 'June'];

  // const data = {
  //   labels,
  //   datasets: [
  //     {
  //       label: 'Dataset 1',
  //       data: ['a','b','c','d','e','f'],
  //       borderColor: 'rgb(255, 99, 132)',
  //       backgroundColor: 'rgba(255, 99, 132, 0.5)',
  //     },
  //     {
  //       label: 'Dataset 2',
  //       data: [1,2,3,4,5,6],
  //       borderColor: 'rgb(53, 162, 235)',
  //       backgroundColor: 'rgba(53, 162, 235, 0.5)',
  //     },
  //   ],
  // };
  const BarrasHorizontal = ({ title, color, dados })=>{

    var data='';

    tituloGrafico = title;
  
    useEffect(()=>{

      console.log(dados);

      let total = 0;
      if(dados.valores){
        dados.valores.forEach(valor=>{
          total += Number(valor)
        })
      }
    },[]) // eslint-disable-line react-hooks/exhaustive-deps
  
    if (typeof dados != "undefined") {
  
      data = {
        labels:dados.lojas,
        datasets: [
          {
            labels: dados.lojas,
            pointRadius: "0",
            pointHoverRadius: "0",
            backgroundColor: colorChats.vivida,
            borderWidth: "0",
            data: dados.valores
          }
        ]
      }
    
    } else {
        return (<></>)
    }
  
    return (
      <HorizontalBar
        data={data}
        options={options}
        width={650}
        height={null}
      />
      
      // <Card className='mb-0 mt-4'>
      //   <CardHeader>
      //     <Row>
      //       <Col sm="7">
      //         <div className="numbers pull-left grafico-valor">{totalGrafico}</div>
      //       </Col>
      //       <Col sm="5">
      //         <div className="pull-right">
      //           <Badge className={color} pill>
      //             {title}
      //           </Badge>
      //         </div>
      //       </Col>
      //     </Row>
      //   </CardHeader>
      //   <CardBody>
      //     <HorizontalBar
      //       data={data}
      //       options={options}
      //       width={550}
      //       height={null}
      //     />
      //   </CardBody>
      // </Card>
    )
}

export default BarrasHorizontal;